import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_receipt_tax, report_receipt } from "../../../components/Report.js";
export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_invoice: false,
      data_customer: [],
      data_bank: [],
      data_invoice: [],

      transaction_list: [],

      uid: "",
      customer_id: "",
      address: "",
      phone: "",
      ref_no: "",
      date: "",
      due_date: "",
      status: "",

      cash_amount: "",
      transfer_amount: "",
      transfer_bank_account: "",
      transfer_date: "",
      transfer_time: "",
      credit_amount: "",
      credit_bank_account: "",
      credit_date: "",
      check_number: "",

      pay_amount: "",
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    if (params("id")) {
      await this.GetByID(params("id"));
    }

    loading(false);
  }
  Get = async () => {
    let data_customer, data_bank;
    let [result_customer, result_bank] = await Promise.all([
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
      GET("admin/setting/banks/list", { page: 0, data_search: "" }),
    ]);
    if (result_customer?.status) {
      
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }
    if (result_bank?.status) {
      data_bank = result_bank.data.map((e) => ({
        value: e.uid,
        label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
      }));
    }
    this.setState({
      data_customer,
      data_bank,
    });
  };
  GetByID = async (id) => {
    loading(true);
    let result = await GET("admin/billing-notes/list", { uid: id });
    
    let item = result.data;
    if (item.status === "ยกเลิก") {
      window.location.href = "/invoice/billings";
    }
    this.setState({
      uid: item.uid,
      customer_id: item.customer?.uid || "",
      address: item.address,
      phone: item.phone,
      ref_no: item.ref_no,
      date: format_date(item.created_at, "yyyy-mm-dd", "en"),
      due_date: format_date(item.due_date, "yyyy-mm-dd", "en"),
      transaction_list: item.invoice.map((e) => ({ ...e, checked: false })),
      status: item.status,
    });

    loading(false);
  };
  GetInvoiceByID = async () => {
    const { customer_id } = this.state;
    loading(true);
    let [result] = await Promise.all([
      GET("admin/invoices/list", {
        page: 0,
        data_search: "",
        customer_id: customer_id,
      }),
    ]);
    if (result?.status) {
      this.setState({
        data_invoice: result.data.filter((e) => e.status === "รอชำระ"),
        modal_invoice: true,
      });
    }
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      data_bank,
      uid,

      transaction_list,

      pay_amount,

      cash_amount,
      transfer_amount,
      credit_amount,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_bank_account,
      credit_date,
      check_number,
    } = this.state;
    let total_pay =
      Number(cash_amount) + Number(transfer_amount) + Number(credit_amount);
    // if (total_pay !== Number(pay_amount)) {
    //   alert(
    //     "",
    //     "warning",
    //     "แจ้งเตือน",
    //     "ยอดชำระไม่เท่ากับยอดเงินที่ต้องการชำระ"
    //   );
    //   return;
    // }
    let _total = 0;
    transaction_list.forEach((item) => {
      _total +=
        (item.sale?.is_vat
          ? (Number(item.sale?.amount_net) - total(item.credit_note, "amount")) * 1.07
          : (Number(item.sale?.amount_net) - total(item.credit_note, "amount"))) -
        Number(item.sale?.total_pay);
    });
    _total = 0 < _total ? _total : 0;
    loading(true);
    let body = {
      overdue: _total - pay_amount,
      total_amount: pay_amount,
      invoice_pay: transaction_list
        .filter((e) => e.checked)
        .map((e) => ({ uid: e.uid, amount: Number(e.pay_amount || 0) })),
      payment: {
        cash_amount: Number(cash_amount),
        transfer_amount: Number(transfer_amount),
        transfer_bank_account: transfer_bank_account,
        transfer_date: transfer_date || null,
        transfer_time: transfer_time,
        credit_amount: Number(credit_amount),
        credit_bank_account: credit_bank_account,
        credit_date: credit_date || null,
        check_number: check_number,
        change: 0,
      },
    };
    let result = await PUT("admin/billing-notes/update/" + uid, body);
    if (result?.status) {
      alert("/invoice/billings", "success");
      const _transfer_bank_account = data_bank.find(e=>e.value === transfer_bank_account)
      const _credit_bank_account = global.bank.find(e=>e.value === credit_bank_account)
      report_receipt(uid, {
            cash_amount: cash_amount,
            transfer_amount: transfer_amount,
            transfer_bank_account: _transfer_bank_account,
            transfer_date: transfer_date,
            transfer_time: transfer_time,
            credit_amount: credit_amount,
            credit_bank_account: _credit_bank_account,
            credit_date: credit_date,
            check_number: check_number,
          });
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  CreateUpdateBilling = async () => {
    const { data_invoice, transaction_list, uid } = this.state;

    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการออกใบวางบิลหรือไม่",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let selected = data_invoice.filter(
        (e) => e.checked && e.status === "รอชำระ"
      );
      let _total = 0;
      for (let item of selected) {
        _total += Number(item.sale?.amount_net);
      }
      for (let item of transaction_list) {
        _total += Number(item.sale?.amount);
      }
      let body = {
        amount: _total,
        invoice_list: selected.map((e) => e.uid),
      };

      

      let result = await PUT(
        "admin/billing-notes/update-add-invoice/" + uid,
        body
      );
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบรายการนี้ออกจากใบวางบิลนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ยกเลิก",
      };

      let result = await PUT("admin/invoices/update-billing/" + id, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_invoice,

      data_customer,
      data_bank,
      data_invoice,
      transaction_list,

      customer_id,
      address,
      phone,
      ref_no,
      date,
      due_date,
      status,

      cash_amount,
      transfer_amount,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,

      pay_amount,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="d-flex align-items-center mb-2">
            <h4 className="fw-bold me-3">ใบวางบิล</h4>
            {Status(status, "primary")}
          </div>
          {/* รายการสินค้า */}

          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ผู้ติดต่อ</div>
                <Select
                  options={data_customer}
                  className="form-control"
                  placeholder="ชื่อลูกค้า..."
                  onChange={(e, i) => {
                    this.setState(
                      { customer_id: e, address: i.address, phone: i.phone },
                      () => {
                        this.GetInvoice(e);
                      }
                    );
                  }}
                  value={customer_id}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                  value={address}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทรศัพท์</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทรศัพท์..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                  maxLength={10}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <span className="wpx-150">เอกสารอ้างอิง</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เอกสารอ้างอิง..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ ref_no: e.target.value });
                  }}
                  value={ref_no}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่ออก</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่ออก..."
                  onChange={(e) => {
                    this.setState({ date: e.target.value });
                  }}
                  value={date}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่ครบกำหนด</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่ครบกำหนด..."
                  onChange={(e) => {
                    this.setState({ due_date: e.target.value });
                  }}
                  value={due_date}
                  disabled={params("type")}
                />
              </div>
            </div>
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">
                      <input
                        type="checkbox"
                  disabled={params("type")}
                        onChange={(event) => {
                          this.setState(
                            {
                              transaction_list: transaction_list.map((item) =>
                                Number(item.sale?.amount_net) -
                                  total(item.credit_note, "amount") -
                                  Number(item.sale?.total_pay) ===
                                0
                                  ? { ...item, pay_amount: "" }
                                  : {
                                      ...item,
                                      checked: event.target.checked,
                                      pay_amount: "",
                                    }
                              ),
                            },
                            () => {
                              let date = transaction_list.find((t) => t.checked)
                                ?.sale?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }
                          );
                        }}
                        checked={
                          transaction_list.length > 0 &&
                          transaction_list
                            .filter(
                              (item) =>
                                Number(item.sale?.amount_net) -
                                  total(item.credit_note, "amount") -
                                  Number(item.sale?.total_pay) !==
                                0
                            )
                            .every((item) => item.checked)
                        }
                      />
                    </td>

                    <td className="text-nowrap">เลขที่เอกสาร</td>
                    <td className="text-nowrap">วันที่ออก</td>
                    <td className="text-nowrap">วันที่ครบกำหนด</td>
                    <td className="text-nowrap  text-end">จำนวนเงินเต็ม</td>
                    <td className="text-nowrap  text-end">
                      ยอดหลังหักใบลดหนี้
                    </td>
                    <td className="text-nowrap  text-end">ค้างชำระ</td>
                    <td className="text-nowrap  text-end">ยอดคืนลูกค้า</td>
                    {/* <td className="text-nowrap text-end">ชำระมัดจำ</td> */}
                    <td className="text-nowrap text-end">
                      มูลค่าที่ต้องการชำระ
                    </td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_list?.map((item, index) => (
                    <>
                      <tr>
                        <td className="text-nowrap">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              transaction_list[index].checked =
                                e.target.checked;
                              transaction_list[index].pay_amount = "";
                              let date = transaction_list.find((t) => t.checked)
                                ?.sale?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                transaction_list,
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }}
                            checked={item.checked}
                            
                  disabled={params("type") || 
                              (item.sale?.is_vat
                                ? Number(item.sale?.amount_net) * 1.07
                                : Number(item.sale?.amount_net)) -
                                Number(item.sale?.total_pay) ===
                              0
                            }
                          />
                        </td>
                        <td className="text-nowrap">
                          {item?.document_no || ""}
                        </td>
                        <td className="text-nowrap">
                          {item.sale?.created_at
                            ? format_date(item.sale?.created_at)
                            : ""}
                        </td>
                        <td className="text-nowrap">
                          {item.sale?.due_date
                            ? format_date(item.sale?.due_date)
                            : ""}
                        </td>
                        <td className="text-nowrap text-end">
                          {toFixed(
                            item.sale?.is_vat
                              ? Number(item.sale?.amount_net) * 1.07
                              : Number(item.sale?.amount_net)
                          )}
                        </td>
                        <td className="text-nowrap text-end">
                          {toFixed(
                            (item.sale?.is_vat
                              ? (Number(item.sale?.amount_net)-total(item.credit_note, "amount")) * 1.07
                              : (Number(item.sale?.amount_net)-total(item.credit_note, "amount")))
                              
                          )}
                        </td>
                        <td className="text-nowrap text-end">
                          {toFixed(
                            (item.sale?.is_vat
                              ? (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")) * 1.07
                              : (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")))  -
                              Number(item.sale?.total_pay) <
                              0
                              ? "0.00"
                              : (item.sale?.is_vat
                                  ? (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")) * 1.07
                                  : (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")))  -
                                  Number(item.sale?.total_pay)
                          )}
                        </td>
                        <td className="text-nowrap text-end">
                          {toFixed(
                            (item.sale?.is_vat
                              ? (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")) * 1.07
                              : (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")))  -
                              Number(item.sale?.total_pay) <
                              0
                              ? (item.sale?.is_vat
                                  ? (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")) * 1.07
                                  : (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount"))) -
                                  Number(item.sale?.total_pay)
                              : "0.00"
                          )}
                        </td>
                        {/* <td className="text-nowrap"><input className="form-control text-end" type="text" onChange={e=>{if(!float(e.target.value))return;transaction_list[index].pay_deposit = e.target.value; this.setState({transaction_list})}} value={item.pay_deposit}/></td> */}
                        <td className="text-nowrap">
                          <input
                            className="form-control text-end"
                            type="text"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              let total_pay =
                                (item.sale?.is_vat
                                  ? (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount")) * 1.07
                                  : (Number(item.sale?.amount_net)-
                              total(item.credit_note, "amount"))) -
                                Number(item.sale?.total_pay);
                              if (total_pay < Number(e.target.value)) {
                                e.target.value = total_pay;
                              }
                              if (Number(e.target.value) < 0) {
                                e.target.value = 0;
                              }
                              transaction_list[index].pay_amount =
                                e.target.value;
                              this.setState({
                                transaction_list,
                                pay_amount: total(
                                  transaction_list,
                                  "pay_amount"
                                ),
                              });
                            }}
                            value={item.pay_amount}
                            disabled={!item.checked}
                          />
                        </td>
                        <td>
                          <div className="d-flex ">
                            {status === "รอชำระ" ? (
                              <BtnIcon
                                type="create"
                                title="ลดหนี้"
                                onClick={() => {
                                  window.location.href =
                                    "/invoice/payment-debt-reduces?id=" +
                                    item.uid;
                                }}
                              />
                            ) : null}
                            {status === "รอชำระ" ? (
                              <BtnIcon
                                type="delete"
                                onClick={() => {
                                  this.Delete(item.uid);
                                }}
                              />
                            ) : null}
                          </div>
                        </td>
                      </tr>
                      {item.credit_note.map((credit, credit_index) => (
                        <tr>
                          <td className="bg-light text-nowrap"></td>
                          <td className="bg-light text-nowrap">
                            {credit?.document_no || ""}
                          </td>
                          <td className="bg-light text-nowrap">
                            {credit?.created_at
                              ? format_date(credit?.created_at)
                              : ""}
                          </td>
                          <td className="bg-light text-nowrap"></td>
                          <td className="bg-light text-nowrap text-end text-danger">
                            -{toFixed(credit?.amount)}
                          </td>
                          <td className="bg-light text-nowrap"></td>
                          <td className="bg-light text-nowrap"></td>
                          <td className="bg-light text-nowrap"></td>
                          {/* <td className="bg-light text-nowrap"></td> */}
                          <td className="bg-light text-nowrap"></td>
                          <td className="bg-light text-nowrap"></td>
                        </tr>
                      ))}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
            {status === "รอชำระ" && (
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-dark px-4"
                  onClick={() => {
                    this.GetInvoiceByID();
                  }}
                >
                  เพิ่มใบแจ้งหนี้
                </button>
              </div>
            )}
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row">
              <div className="col-12 col-md-4 mb-2">
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ยอดรวมทั้งหมด</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      transaction_list.forEach((item) => {
                        _total += item.sale?.is_vat
                          ? Number(item.sale?.amount_net) * 1.07
                          : Number(item.sale?.amount_net);
                      });
                      return toFixed(_total);
                    })()}
                  </b>
                </div>
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ยอดหลังใบลดทั้งหมด</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      transaction_list.forEach((item) => {
                        _total +=
                          (item.sale?.is_vat
                            ? (Number(item.sale?.amount_net) -
                          total(item.credit_note, "amount")) * 1.07
                            : (Number(item.sale?.amount_net) - total(item.credit_note, "amount")));
                      });
                      return toFixed(_total);
                    })()}
                  </b>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-2">
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ยอดคืนลูกค้าทั้งหมด</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      transaction_list.forEach((item) => {
                        _total +=
                          (item.sale?.is_vat
                            ? (Number(item.sale?.amount_net) - total(item.credit_note, "amount")) * 1.07
                            : (Number(item.sale?.amount_net) - total(item.credit_note, "amount"))) -
                          Number(item.sale?.total_pay);
                      });
                      return toFixed(_total < 0 ? _total : 0);
                    })()}
                  </b>
                </div>
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ค้างชำระทั้งหมด</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      transaction_list.forEach((item) => {
                        _total +=
                          (item.sale?.is_vat
                            ? (Number(item.sale?.amount_net) - total(item.credit_note, "amount")) * 1.07
                            : (Number(item.sale?.amount_net) - total(item.credit_note, "amount")))  -
                          Number(item.sale?.total_pay);
                      });
                      return toFixed(0 < _total ? _total : 0);
                    })()}
                  </b>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-2">
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>ยอดชำระแล้วทั้งหมด</span>
                  <b>
                    {(() => {
                      let _total = 0;
                      transaction_list.forEach((item) => {
                        _total += Number(item.sale?.total_pay);
                      });
                      return toFixed(_total);
                    })()}
                  </b>
                </div>
                <div className="d-flex align-items-center justify-content-between hpx-50">
                  <span>มูลค่าที่รับชำระ</span>
                  <input
                    type="text"
                    className="form-control text-end wpx-200 hpx-40"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      let _total = Number(e.target.value);
                      let _transaction_list = transaction_list.map((e) => ({
                        ...e,
                        pay_amount: "",
                      }));
                      let total_amount = 0;
                      for (let item of _transaction_list) {
                        total_amount +=
                          (item.sale?.is_vat
                            ? (Number(item.sale?.amount_net) - total(item.credit_note, "amount")) * 1.07
                            : (Number(item.sale?.amount_net) - total(item.credit_note, "amount")))  -
                          Number(item.sale?.total_pay);
                      }
                      if (total_amount < _total) {
                        e.target.value = total_amount < 0 ? 0 : total_amount;
                      }
                      for (let item of _transaction_list) {
                        let total_pay =
                          (item.sale?.is_vat
                            ? (Number(item.sale?.amount_net) - total(item.credit_note, "amount")) * 1.07
                            : (Number(item.sale?.amount_net) - total(item.credit_note, "amount"))) -
                          Number(item.sale?.total_pay);
                        if (0 < _total) {
                          if (0 < _total - total_pay) {
                            item.pay_amount = total_pay;
                            _total = _total - total_pay;
                          } else {
                            item.pay_amount = _total;
                            _total = 0;
                          }
                        }
                        if (Number(item.pay_amount || 0) > 0) {
                          item.checked = true;
                        } else {
                          item.checked = false;
                        }
                      }
                      this.setState({
                        transaction_list: _transaction_list,
                        pay_amount: e.target.value,
                      });
                    }}
                    value={pay_amount}

                  disabled={params("type")}
                  />
                </div>
              </div>
            </div>
          </div>

          {!params("type") && (
          <div className="row mb-5 pb-5">
            {/* ชำระเงินสด */}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div
                className="rounded-4 bg-white p-3"
                style={{ height: "100%" }}
              >
                <h5 className="fw-bold mb-0">ชำระเงินสด</h5>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">จำนวนเงิน</span>
                  <input
                    type="text"
                    className="form-control text-end"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ cash_amount: e.target.value });
                    }}
                    value={cash_amount}
                  />
                </div>
                {/* <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เงินทอน</span>
                  <b>{toFixed(cash_amount || 0)} บาท</b>
                </div> */}
              </div>
            </div>
            {/* ชำระเงินโอน */}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div
                className="rounded-4 bg-white p-3"
                style={{ height: "100%" }}
              >
                <h5 className="fw-bold mb-0">ชำระเงินโอน</h5>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">จำนวนเงิน</span>
                  <input
                    type="text"
                    className="form-control text-end"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ transfer_amount: e.target.value });
                    }}
                    value={transfer_amount}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">บัญชีธนาคาร</span>
                  <Select
                    options={data_bank}
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ transfer_bank_account: e });
                    }}
                    value={transfer_bank_account}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">วันที่โอน</span>
                  <DatePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ transfer_date: e });
                    }}
                    value={transfer_date}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เวลาที่โอน</span>
                  <input
                    type="time"
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ transfer_time: e.target.value });
                    }}
                    value={transfer_time}
                  />
                </div>
              </div>
            </div>
            {/* ชำระเช็ค */}
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div
                className="rounded-4 bg-white p-3"
                style={{ height: "100%" }}
              >
                <h5 className="fw-bold mb-0">ชำระเช็ค</h5>
                <hr />
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">จำนวนเงิน</span>
                  <input
                    type="text"
                    className="form-control text-end"
                    placeholder="0.00"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ credit_amount: e.target.value });
                    }}
                    value={credit_amount}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">บัญชีธนาคาร</span>
                  <Select
                    options={global.bank}
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ credit_bank_account: e });
                    }}
                    value={credit_bank_account}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">วันที่หน้าเช็ค</span>
                  <DatePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ credit_date: e });
                    }}
                    value={credit_date}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เลขที่เช็ค</span>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ check_number: e.target.value });
                    }}
                    value={check_number}
                  />
                </div>
              </div>
            </div>
          </div>
          )}
        </div>
        {!params("type") && (
        <div
          className="position-fixed w-100 bg-white d-flex justify-content-end p-3"
          style={{ bottom: 0, left: 0 }}
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              this.CreateUpdate();
            }}
          >
            รับชำระ
          </button>
        </div>
         )}

        {/* CREATE UPDATE */}
        <Modal
          show={modal_invoice}
          onHide={() => this.setState({ modal_invoice: false })}
          fullscreen={true}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เพิ่มใบลดหนี้ในใบวางบิล</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td>
                      {" "}
                      <input
                        type="checkbox"
                        checked={data_invoice
                          ?.filter((e) => e.status !== "เสร็จสิ้น")
                          .every((e) => e.checked)}
                        onChange={(e) => {
                          this.setState(
                            {
                              data_invoice: data_invoice?.map((t) => {
                                return t.status === "เสร็จสิ้น"
                                  ? t
                                  : {
                                      ...t,
                                      checked: e.target.checked,
                                    };
                              }),
                            },
                            () => {
                              let date = data_invoice.find((t) => t.checked)
                                ?.sale?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }
                          );
                        }}
                      />
                    </td>
                    <td className="text-nowrap">วันที่ส่งสินค้า</td>
                    <td className="text-nowrap">รหัสเอกสาร</td>
                    <td className="text-nowrap">กำหนดชำระ</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">ประเภท Vat</td>
                    <td className="text-nowrap text-end">จำนวนเงิน (บาท)</td>
                    <td className="text-nowrap text-end">ลดหนี้</td>
                    <td className="text-nowrap text-end">ชำระแล้ว</td>
                    <td className="text-nowrap text-end">ค้างชำระ</td>
                    <td className="text-nowrap text-end">ยอดเงินคืนลูกค้า</td>
                    <td className="text-nowrap">สถานะ</td>
                  </tr>
                </thead>
                <tbody>
                  {data_invoice?.map((item, index) => (
                    <tr>
                      <td>
                        {item.status === "รอชำระ" && (
                          <input
                            type="checkbox"
                            checked={item.checked}
                            onChange={(e) => {
                              data_invoice[index].checked = e.target.checked;
                              let date = data_invoice.find((t) => t.checked)
                                ?.sale?.created_at;
                              date = date ? new Date(date) : new Date();
                              this.setState({
                                data_invoice,
                                due_date: format_date(
                                  new Date(
                                    date.getFullYear(),
                                    date.getMonth() + 1,
                                    25
                                  ),
                                  "yyyy-mm-dd",
                                  "en"
                                ),
                              });
                            }}
                          />
                        )}
                      </td>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.document_no || ""}</td>
                      <td className="text-nowrap">
                        {item.sale?.due_date
                          ? format_date(item.sale?.due_date)
                          : format_date(new Date())}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.sale?.receipt_type || ""}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          item.sale?.receipt_type === "ต้องการ Vat"
                            ? item.sale?.amount_net * 1.07
                            : item.sale?.amount_net
                        )}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(total(item.credit_note, "amount"))}
                      </td>

                      <td className="text-nowrap text-end"></td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          item.sale?.receipt_type === "ต้องการ Vat"
                            ? (Number(item.sale?.amount_net) - total(item.credit_note, "amount")) * 1.07
                            : (Number(item.sale?.amount_net) - total(item.credit_note, "amount"))
                        )}
                      </td>
                      <td className="text-nowrap text-end"></td>
                      <td className="text-nowrap">{item.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdateBilling();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_invoice: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
